export const actions = {
    SET_BUSINESS_OBJECT: "SET_BUSINESS_OBJECT",
};

export const setBusinessObject = (object: any) => {
    return (dispatch) => {
        dispatch({
            type: actions.SET_BUSINESS_OBJECT,
            payload: object
        })
    }
};


// WEBPACK FOOTER //
// ./app/actions/manageDataBusinessObjectActions.ts